import { takeEvery, call } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, reportApi, ReportNS, reportSlice } from 'Modules'

function* getReport(action: ReportNS.GetReport) {
	try {
		const { typeReport, requestParams, columns } = action.payload
		if (columns) {
			yield* call(reportApi.getReportWithConfig, typeReport, requestParams, columns)
		} else {
			yield* call(reportApi.getReport, typeReport, requestParams)
		}

		yield* call(notifyMessageCreator, 'common.report_send.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* setReport(action: ReportNS.SetReport) {
	try {
		yield* call(reportApi.setReport, action.payload)
		yield* call(notifyMessageCreator, 'common.report_send.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* reportSaga() {
	yield* takeEvery(reportSlice.actions.getReport.type, getReport)
	yield* takeEvery(reportSlice.actions.setReport.type, setReport)
}
